export class Quality {
  private static _values: Quality[] = [];
  private static _lookup: Map<number, Quality> = new Map();

  static fromId(id: number) {
    const instance = Quality._lookup.get(id);
    if (instance === undefined) {
      throw new Error('Not a valid Quality.id: ' + id);
    }
    return instance;
  }

  static values(): Quality[] {
    return [...Quality._values];
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Quality._values.push(this);
    Quality._lookup.set(id, this);
  }

  toJson(): { id: number; name: string } {
    return { id: this.id, name: this.label };
  }

  toString(): string {
    return '<Quality: ' + this.id + ", label='" + this.label + "'>";
  }
}
